import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.scss';
import ScrollToTop from './components/shared/ScrollToTop';

import Home2025 from './pages/2025/page';
import TimeTable2025 from './pages/2025/timetable';
import Access2025 from './pages/2025/access';
import News2025 from './pages/2025/news';
import NewsDetail2025 from './pages/2025/news/[id]';
import NewsPreview2025 from './pages/2025/news/preview';
import Blog2025 from './pages/2025/blog';
import BlogDetail2025 from './pages/2025/blog/[id]';
import Events2025 from './pages/2025/events';
import EventsSpecial2025 from './pages/2025/events/special';
import EventsFestival2025 from './pages/2025/events/festival';
import EventsTut2025 from './pages/2025/events/tut';
import EventsNeec2025 from './pages/2025/events/neec';
import EventsJapaneseSchool2025 from './pages/2025/events/japanese-school';
import Map2025 from './pages/2025/map';
import Message2025 from './pages/2025/message';
import Preview2025 from './pages/2025/preview';
import ShopPreview2025 from './pages/2025/map/preview';

// アーカイブサイト（iframe）
import Archive2022 from './pages/2022';
import Archive2023 from './pages/2023';
import Archive2024 from './pages/2024';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Routes>
          {/* ルートアクセスは現在の年度（2025）にリダイレクト */}
          <Route path="/" element={<Navigate to="/2025" replace />} />

          {/* 過去年度アーカイブ（iframe） */}
          <Route path="/2022" element={<Archive2022 />} />
          <Route path="/2022/*" element={<Archive2022 />} />
          <Route path="/2023" element={<Archive2023 />} />
          <Route path="/2023/*" element={<Archive2023 />} />
          <Route path="/2024" element={<Archive2024 />} />
          <Route path="/2024/*" element={<Archive2024 />} />

          {/* 2025年度のルート */}
          <Route path="/2025" element={<Home2025 />} />
          <Route path="/2025/map" element={<Map2025 />} />
          <Route path="/2025/map/preview" element={<ShopPreview2025 />} />
          <Route path="/2025/timetable" element={<TimeTable2025 />} />
          <Route path="/2025/access" element={<Access2025 />} />
          <Route path="/2025/news" element={<News2025 />} />
          <Route path="/2025/news/preview" element={<NewsPreview2025 />} />
          <Route path="/2025/news/:id" element={<NewsDetail2025 />} />
          <Route path="/2025/blog" element={<Blog2025 />} />
          <Route path="/2025/blog/:id" element={<BlogDetail2025 />} />
          <Route path="/2025/events" element={<Events2025 />} />
          <Route path="/2025/events/special" element={<EventsSpecial2025 />} />
          <Route path="/2025/events/festival" element={<EventsFestival2025 />} />
          <Route path="/2025/events/tut" element={<EventsTut2025 />} />
          <Route path="/2025/events/neec" element={<EventsNeec2025 />} />
          <Route path="/2025/events/japanese-school" element={<EventsJapaneseSchool2025 />} />
          <Route path="/2025/message" element={<Message2025 />} />
          <Route path="/2025/preview" element={<Preview2025 />} />

          {/* 将来的に2026年度を追加する場合 */}
          {/* <Route path="/2026" element={<Home2026 />} /> */}
        </Routes>
      </div>
    </Router>
  );
}

export default App;
